import Vue from 'vue'
import Router from 'vue-router';
import App from '@/App';


Vue.use(Router)

const routes = [

    {
        path: '*',
        name: '404',
    },

    {
        path: '/teste',
        name: 'teste',
        component: App
    },
    {
        path: '/',
        name: 'home',
        component: App
    },
    {
        path: '/agency',
        name: 'agency',
        component: App
    },
    {
        path: '/brands',
        name: 'brands',
        component: App
    },
    {
        path: '/ideas',
        name: 'work',
        component: App
    },
    {
        path: '/people',
        name: 'culture',
        component: App
    },
    {
        path: '/contact',
        name: 'contact',
        component: App
    },
    {
        path: '/chocapic',
        name: 'choca',
        component: App
    },
    {
        path: '/new-business',
        name: 'new',
        component: App
    },

    {
        // path: '/:lang/detail/:id',
        path: '/project/:id',
        name: 'project',
        component: App
        //meta: { gtm: 'Detail' },
    },



];


/*


if(window.location.hostname != '0.0.0.0') {

    for(var i = 0; i < routes.length; i++){

        var pth = routes[i].path;
        routes[i].path = '/MOT' + pth;
        console.log(routes[i].path)
    }
}
*/

const router = new Router({
    mode: 'history',
    routes,
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js